import React from "react";
import styles from "./style/FeatureFlag.module.css";

// Define the ConfirmationBox component to display confirmation messages
export const ConfirmationBox = ({ message, onClose }) => (
  <div className={styles.confirmation_box}>
    <p>
      {message.split("\n").map((text, index) => (
        <React.Fragment key={index}>
          {text}
          <br />
        </React.Fragment>
      ))}
    </p>

    <button onClick={onClose} className={styles.confirmation_button}>
      OK
    </button>
  </div>
);
